export const DEFAULT_CASH_IN = 5;
export const DEFAULT_CHIPS = 10000;
export const DEFAULT_CHIP_UNIT = 100;
export const CHIPS_PER_CASH_UNIT = DEFAULT_CHIPS / DEFAULT_CASH_IN;
export const SELECTABLE_CURRENCIES = ["EUR", "USD", "GBP", "JPY", "INR", "KRW"] as const;
export type SelectableCurrency = (typeof SELECTABLE_CURRENCIES)[number];
export const CURRENCY_STORAGE_KEY = "pokersplitter.selectedCurrency";
